import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-OU-logo_svg__Layer_1",
  viewBox: "0 0 90.9 90.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-OU-logo_svg__cls-1{fill:#1a386e}.svg-OU-logo_svg__cls-2{fill:#c10016}.svg-OU-logo_svg__cls-3{fill:#007abf}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<path d=\"M74.3 38.6h16.6v16.6H74.3z\" class=\"svg-OU-logo_svg__cls-2\"></path><path d=\"M18 60.5h11.1v11.1H18z\" class=\"svg-OU-logo_svg__cls-3\"></path><path d=\"M56.3 59.4h13.3v13.4H56.3zM36.4 40H50v13.6H36.4z\" class=\"svg-OU-logo_svg__cls-1\"></path><path d=\"M54.6 19.2h16.6v16.6H54.6zM74.3 0h16.6v16.6H74.3z\" class=\"svg-OU-logo_svg__cls-2\"></path><path d=\"M0 81.4h7.7v7.7H0zM37.8 79.9h10.9v10.9H37.8z\" class=\"svg-OU-logo_svg__cls-3\"></path>", 5))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "OU-logo"}) } }